import { Gap, FormItem, ISelectOption, Select, SelectMini } from '@salecycle/ui-component-library';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { GroupSelect } from './GroupSelect';
import { BrandSelect } from './BrandSelect';
import { SiteSelect } from './SiteSelect';
import { ClientLevel } from 'core/types';

const Container = styled.div`
  display: flex;
`;

const LevelContainer = styled.div<{ isMini: boolean }>`
  ${({ isMini }) => (isMini ? '' : 'width: 150px;')}
`;

interface Props {
  groupsEnabled?: boolean;
  brandsEnabled?: boolean;
  sitesEnabled?: boolean;
  isMini?: boolean;
  level: ClientLevel;
  onLevelChanged: (level: ClientLevel) => void;
  groupId?: string;
  onGroupChanged?: (groupId: string) => void;
  brandId?: string;
  onBrandChanged?: (brandId: string) => void;
  siteId?: string;
  onSiteChanged?: (siteId: string) => void;
}

export function ClientSelect({
  groupsEnabled: groupEnabled = true,
  brandsEnabled: brandEnabled = true,
  sitesEnabled: siteEnabled = true,
  isMini = false,
  level,
  onLevelChanged,
  groupId,
  onGroupChanged,
  brandId,
  onBrandChanged,
  siteId,
  onSiteChanged,
}: Props) {
  const { t } = useTranslation('components');

  const handleLevelChange = (option: ISelectOption<ClientLevel>) => {
    if (option?.value) {
      onLevelChanged(option.value);
    }
  };

  const levels = [];
  if (groupEnabled) levels.push({ label: 'Group', value: ClientLevel.GROUP });
  if (brandEnabled) levels.push({ label: 'Brand', value: ClientLevel.BRAND });
  if (siteEnabled) levels.push({ label: 'Site', value: ClientLevel.SITE });

  //Find the ISelectOption associated with this siteId
  const levelValue = levels.find(l => l.value === level);
  const inputId = 'level-select';

  return (
    <Container>
      <LevelContainer data-testid="LevelSelectContainer" isMini={isMini}>
        <FormItem
          isMini={isMini}
          spacingBelow={false}
          label={`${t('levelSelect.label')}${isMini ? ':' : ''}`}
          for={inputId}
        >
          {isMini ? (
            <SelectMini
              ariaLabel={t('levelSelect.aria')}
              value={levelValue}
              onChange={handleLevelChange}
              options={levels}
              searchable={false}
              // TODO:DJ needs an inputId prop to allow label targetting
            />
          ) : (
            <Select
              ariaLabel={t('levelSelect.aria')}
              value={levelValue}
              onChange={handleLevelChange}
              options={levels}
              searchable={false}
              inputId={inputId}
            />
          )}
        </FormItem>
      </LevelContainer>
      <Gap left={isMini ? 35 : 50} />
      {level === ClientLevel.GROUP && <GroupSelect isMini={isMini} groupId={groupId} onGroupChanged={onGroupChanged} />}
      {level === ClientLevel.BRAND && <BrandSelect isMini={isMini} brandId={brandId} onBrandChanged={onBrandChanged} />}
      {level === ClientLevel.SITE && <SiteSelect isMini={isMini} siteId={siteId} onSiteChanged={onSiteChanged} />}
    </Container>
  );
}
